export function accordionHandler() {
    $(".card-header").click(function () {
        if (!$(this).is('.rotate-arrow')) {
            $('.card-header').removeClass('rotate-arrow');
        }
        $(this).toggleClass('rotate-arrow');
    });

    $('#accordionSingleBolestPage .card:first-of-type .card-header').trigger('click');

    $('#accordionSingleLekPage .card:first-of-type .card-header').trigger('click');
}